import { twResolve } from "@/helpers/tw-resolve";

interface NumericBadgeProps {
  count: number;
  variant?: "outlined" | "filled";
}

export function NumericBadge({ count, variant = "outlined" }: NumericBadgeProps): React.ReactNode {
  return (
    <span
      className={twResolve(
        "inline-flex h-numeric-badge min-w-numeric-badge shrink-0 items-center justify-center rounded-full border border-border-default bg-background-default px-numeric-badge-default text-caption leading-none! text-text-primary",
        variant === "filled" && "border-none bg-background-numeric-badge text-text-on-brand",
      )}
    >
      {count}
    </span>
  );
}
